// export default (function() {
// 	function pxtorem() {
// 		let html = document.documentElement;
// 		let htmlW = html.clientWidth;
// 		let desginW = 750;
// 		if (htmlW >= desginW) {
// 			html.style.fontSize = '100px';
// 		}
// 		html.style.fontSize = (htmlW / desginW) * 100 + 'px';
// 	}
// 	pxtorem();
// 	window.addEventListener('resize', pxtorem);

// })()

// // rem等比适配配置文件
// // 基准大小
// const baseSize = 192
// // 设置 rem 函数
// function pxtorem() {
// 	// 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
// 	const scale = document.documentElement.clientWidth / 1920
// 	// 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
// 	// document.documentElement.style.fontSize = baseSize * Math.max(scale, 0.) + 'px'
// 	if (window.innerWidth > 1400) {
// 		document.documentElement.style.fontSize = baseSize * Math.max(scale, 0.6) + 'px'
// 	} else {
// 		document.documentElement.style.fontSize = baseSize * Math.max(scale, 0.8) + 'px'
// 	}
// }
// // 初始化
// pxtorem()
// // 改变窗口大小时重新设置 rem
// window.onresize = function() {
// 	pxtorem()
// }


! function(n) {
	var e = n.document,
		t = e.documentElement,
		i = 720,
		d = i / 100,
		o = "orientationchange" in n ? "orientationchange" : "resize",
		a = function() {
			var n = t.clientWidth || 320;
			n > 720 && (n = 720);
			t.style.fontSize = n / d + "px"
		};
	e.addEventListener && (n.addEventListener(o, a, !1), e.addEventListener("DOMContentLoaded", a, !1))
}(window);
